export default {
  items: [
    {
      moduleCode: '',
      screenCode: '',
      name: 'My Tasks',
      url: '/dashboard',
      icon: 'icon-notebook',
    },
    {
      moduleCode: '',
      screenCode: '',
      name: 'BCM Dashboard',
      url: '/BCM Dashboard',
      icon: 'icon-speedometer',
      class: 'parent-nav',
      children: [
        {
          moduleCode: '',
          screenCode: '', 
          name: 'BCM Profile',
          url: '/stimulsoft_bcm_profile',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: '', 
          name: 'BCM Progress',
          url: '/stimulsoft_bcm_progress',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: '', 
          name: 'BCM System Dependencies',
          url: '/stimulsoft_system_dependencies',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
  ],
};
